import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Faltan las variables de entorno REACT_APP_SUPABASE_URL o REACT_APP_SUPABASE_ANON_KEY. Revisa tu archivo .env y reinicia el servidor de desarrollo.',
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
